import { render, staticRenderFns } from "./setPlan.vue?vue&type=template&id=665e6d1a&scoped=true"
import script from "./setPlan.vue?vue&type=script&lang=js"
export * from "./setPlan.vue?vue&type=script&lang=js"
import style0 from "./setPlan.vue?vue&type=style&index=0&id=665e6d1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665e6d1a",
  null
  
)

export default component.exports